import React from "react";
import {
  UserPostImageUpload,
  VideoUpload,
  VideoImagePost,
} from "..";
import { AiOutlineClose } from "react-icons/ai";

type UpLoadBoxProps = {
  selectedVideos: (string | File)[];
  totalVideos: number;
  imageUpload: string[];
  totalImages: number;
  handleIconClick: () => void;
  handleClose: () => void;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onVideoSelectFile: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleClick: (index: number) => void;
  setShowAllImages: React.Dispatch<React.SetStateAction<number | null>>;
  isVideoCompressing: boolean;
  showAllMedia: number | null;
  allMediaUrls: (string | File)[];
  thumbnail: any;
};
const UpLoadBox: React.FC<UpLoadBoxProps> = ({
  selectedVideos,
  totalVideos,
  imageUpload,
  totalImages,
  handleIconClick,
  handleClose,
  handleImageChange,
  fileInputRef,
  onVideoSelectFile,
  handleClick,
  setShowAllImages,
  allMediaUrls,
  showAllMedia,
  isVideoCompressing,
  thumbnail,
}) => {
  return (
    <div
      className={`w-full h-[186px] transition-all ease-linear duration-700 border border-[#D9E2E3] rounded-[10px] bg-[#F4F4F4] flex items-center justify-center relative p-1 overflow-y-auto ${
        (allMediaUrls?.length === 3 ||
          allMediaUrls?.length === 4) &&
        "pt-[50%]"
      }`}
    >
      {!imageUpload?.length && !selectedVideos?.length && (
        <div
          onClick={handleIconClick}
          className="text-center w-[115px] flex flex-col font-Poppins text-xs font-normal text-[#1A202C] cursor-pointer"
        >
          Browse
          <span className="text-lightGreen">Photos / Videos</span>
        </div>
      )}
      <div
        className="flex bg-white items-center justify-center rounded-full h-8 w-8 absolute cursor-pointer top-1 right-2 z-10"
        onClick={() => handleClose()}
      >
        <AiOutlineClose size={20} />
      </div>

      {(imageUpload?.length > 0 || selectedVideos?.length > 0) && (
        <div className="flex gap-1 shadow-sm h-7 items-center z-10 px-2 bg-white rounded-lg absolute top-1 left-2">
          <div
            onClick={() => {
              handleIconClick();
            }}
            className="font-Poppins font-semibold cursor-pointer text-[15px] text-midGreen"
          >
            Add Photos /Videos
          </div>
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        accept="image/*, video/*, application/pdf"
        multiple
        onChange={(e) => {
          const file = e.target.files?.[0]; // Assuming you're selecting only one file at a time
          if (file) {
            if (file.type.startsWith("image/")) {
              handleImageChange(e);
            } else if (file.type.startsWith("video/")) {
              onVideoSelectFile(e);
            }
          }
        }}
        className="invisible hidden"
      />

      {allMediaUrls?.length > 1  ? (
        <VideoImagePost
          allMediaUrls={allMediaUrls}
          handleClick={handleClick}
          thumbnail={thumbnail}
        />
      ) : imageUpload?.length > 0 ? (
        <UserPostImageUpload
          imageUpload={imageUpload}
          totalImages={totalImages}
          handleClick={handleClick}
          setShowAllImages={setShowAllImages}
        />
      ) : (
        selectedVideos?.length > 0 && (
          <VideoUpload
            selectedVideos={selectedVideos}
            totalVideos={totalVideos}
            setShowAllMedia={setShowAllImages}
            handleClick={handleClick}
            thumbnail={thumbnail}
          />
        )
      )}
    </div>
  );
};

export default UpLoadBox;
